import React, {useMemo, useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import { useReactTable, getCoreRowModel, getFilteredRowModel, flexRender } from "@tanstack/react-table";
import { actualizarDatos, crearDatos, filterData, getConsultarAgenda } from "../../api/common";
import jwt_token from 'jwt-decode';
import { Alertassw } from "../Alertas/Alertassw";
import Swal from 'sweetalert2'
import { CalendarioApp } from "../CalendarioApp/CalendarioApp";
import moment from "moment";
import Spinner from "../commons/Spinner";
import { Modalcarga } from "../Modales/Modalcarga";
import { LoadingModal } from "../commons/LoadingSpiner";


const ProgramacionPorEquipo = ({ data, refresh, setRefresh, cambiarestado }) => {

  const [selectedEquipos, setSelectedEquipos] = useState([]);
  // selectedResponsables = [{ value, label }] | liderId = string (uno de los values)
  const [selectedResponsables, setSelectedResponsables] = useState([]);
  const [liderId, setLiderId] = useState("");
  const [responsables, setResponsables] = useState([]);
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaCierre, setFechaCierre] = useState("");
  const [user, setUserData]=useState({})
  const [soloAutorizados, setSoloAutorizados] = useState(false);
  const [selectAllFiltrados, setSelectAllFiltrados] = useState(false);
  const [showModal, setShowModal]=useState(false)
  const [modalSpinner, setModalSpinner]=useState(false)

  // Lista ordenada de IDs para usar como dependencia estable de useEffect.
  const responsablesIdsKey = selectedResponsables.map(r => r.value).sort().join('|');

  // Auto-ajustar el líder: si no hay líder y se agrega el primer responsable, asignarlo.
  // Si el líder actual deja de estar en la lista, pasar al primero restante.
  useEffect(() => {
    if (selectedResponsables.length === 0) {
      if (liderId) setLiderId("");
      return;
    }
    const sigueEnLista = selectedResponsables.some(r => String(r.value) === String(liderId));
    if (!sigueEnLista) {
      setLiderId(String(selectedResponsables[0].value));
    }
  }, [responsablesIdsKey]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setSoloAutorizados(false);
    setSelectAllFiltrados(false)
  // 1. Limpiar los equipos seleccionados
  setSelectedEquipos([]);

  // 2. Resetear filtros de la tabla
  table.resetColumnFilters();
  table.resetGlobalFilter();

  // 3. (Opcional) Resetear paginación o sort si quieres
  table.resetSorting();
  table.resetPagination();

}, [responsablesIdsKey]);

  useEffect(() => {   
          async function postClientes(){
           const clientesDB = await filterData("usuarios",[ // Body para la consuta aggregate de mongo para metrologos y que esten activos.
            {
              "$match": {
                'status': 'activo'
              } 
            },
            {
              "$lookup": {
                "from": "roles",
                "localField": "role",
                "foreignField": "_id",
                "as": "result"
              }
            },
            {
              "$match": {
                "result.nombre":"Metrologo"
              }
            }
          ]);
  
             const cl = clientesDB.data.data.map((client)=>({
              value:client._id,
              label:client.nombre + " "+ client.apellido ,
          }));
          setResponsables(cl)
          }
          async function getUserData(){
            const user = await jwt_token(localStorage.getItem('token'));
            setUserData(user)
            }
            getUserData()
          postClientes()
      },[])

  const toggleEquipo = (id) => {
    setSelectedEquipos(prev => prev.includes(id) ? prev.filter(e => e !== id) : [...prev, id]);
  };

  const handleAbierta=async(e)=>{
    e.preventDefault();
    // 1️⃣ Mostrar el modal de confirmación
    const result = await Swal.fire({
      title: '¿Deseas programar la OT A modo Abierta?',
      text: 'Esta acción marcará la OT como abierta disponible para que cualquier responsable pueda realizar procesar los ítems autorizados sin una programcion previa .',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, Programar',
      cancelButtonText: 'Cancelar'
    });


    // 2️⃣ Si el usuario confirma, ejecutar la actualización
    if (result.isConfirmed) {
      setModalSpinner(true)
      try {
        const responsablesIds = selectedResponsables.map(r => r.value);
        const payload = {
          _id: data._id,
          otAbierta: true,
          responsableApertura: user._id,
          estado:'Programada',
          fechaEntrega: new Date(fechaInicio).toISOString(),
          fechaCierre: new Date(fechaCierre).toISOString(),
          responsable: liderId,
          responsablesVisita: responsablesIds,
        }

        const response = await actualizarDatos('Ot', payload,data._id);
        if(response.status===200){

          Alertassw('success','OT programada como Abierta correctamente');
          setModalSpinner(false)
          setRefresh(!refresh);
          cambiarestado(false);
        }

      } catch (error) {
        setModalSpinner(false)
        console.error(error);
        Swal.fire('Error', 'Error de conexión con el servidor.', 'error');
      }
    }
  }


const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const hoy = new Date();
    const inicio = new Date(fechaInicio);
    const cierre = new Date(fechaCierre);

    // ✅ Validación: campos obligatorios
    if (!liderId || selectedResponsables.length === 0 || !fechaInicio || !fechaCierre || selectedEquipos.length === 0) {
      Alertassw('error', 'Por favor, complete todos los campos requeridos antes de continuar.');
      return;
    }

    // ✅ Validación: fecha inicio no puede ser pasada
    if (inicio <= hoy) {
      Alertassw('error', 'La fecha de inicio no puede ser una fecha pasada.');
      return;
    }

    // ✅ Validación: fecha cierre debe ser posterior a fecha inicio
    if (cierre <= inicio) {
      Alertassw('error', 'La fecha de cierre debe ser posterior a la fecha de inicio.');
      return;
    }

    const responsablesIds = selectedResponsables.map(r => r.value);
    const payload = {
      ot: data._id,
      numeroOrden: data.numeroOrden,
      clientInformation: data.cliente._id,
      equipos: selectedEquipos.map(eq => eq._id),
      responsable: liderId,
      responsablesVisita: responsablesIds,
      fechaInicio: inicio.toISOString(),
      fechaCierre: cierre.toISOString(),
    };

    setModalSpinner(true)

    // 🔍 Consulta de conflictos: por ahora se chequea contra la agenda del líder.
    // TODO: extender getConsultarAgenda para chequear todas las visitas con cualquiera de los responsables.
    const { data: { data: conflictos } } = await getConsultarAgenda(payload, liderId);
    console.log('Conflictos detectados:', conflictos);

    if (conflictos.length > 0) {
      setModalSpinner(false)
      const result = await Swal.fire({
        title: 'Conflicto de programación detectado',
        html: `
          <p>Ya existe una programación dentro del rango de fechas seleccionado.</p>
          <p><strong>Fechas:</strong> ${moment(inicio).format('DD/MM/YYYY HH:mm')} - ${moment(cierre).format('DD/MM/YYYY HH:mm')}</p>
          <p>Verifique el calendario del responsable antes de continuar.</p>
        `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, programar',
        cancelButtonText: 'Cancelar',
      });

      if (!result.isConfirmed) return; // ✅ Más claro que result.isDismissed
    }

    setModalSpinner(true)
    // 💾 Crear nueva programación
    const response = await crearDatos('Programacion', payload);

    setModalSpinner(false)
    Alertassw('success', 'Programación creada correctamente');
    console.log('Respuesta del servidor:', response);

    // 🔄 Refrescar estado y limpiar
    setRefresh(prev => !prev);
    setSelectedEquipos([]);
    cambiarestado(false);

  } catch (error) {
    setModalSpinner(false)
    console.error('Error al crear la programación:', error);
    Alertassw('error', 'Ocurrió un error al crear la programación. Intente nuevamente.');
  }
};


  const columns = useMemo(() => [
    {header: "#", accessorFn: (_row, index) => index + 1, 
        size: 30// muestra 1, 2, 3...
    },
    { header: "Consecutivo", accessorKey: "consecutivo" },
    { header: "Ítem", accessorKey: "snapshot.item" },
    { header: "Marca", accessorKey: "snapshot.marca" },
    { header: "Modelo", accessorKey: "snapshot.modelo" },
    { header: "Sede", accessorKey: "snapshot.sede" },
    { header: "Estado", accessorKey: "estado" },
    {
      header: "Ago",
      cell: ({ row }) => {
          const autorizado = row.original.programacionActual;

          return autorizado ? (
          <label><i class="bi bi-calendar2-check"></i></label>
          ) : (
          null
          );
      }
    },
    {
        header: "Auth",
        cell: ({ row }) => {
            const autorizado = row.original.snapshot.userAutorizados.some(
              u => selectedResponsables.some(r => String(r.value) === String(u))
            );
            return autorizado ? (
            <label><i class="bi bi-person-check-fill"></i></label>
            ) : (
            <label><i class="bi bi-person-lock"></i></label>
            );
        }
    },
    {
      header: "Seleccionar",
      cell: ({ row }) => {
        const autorizado = row.original.snapshot.userAutorizados.some(
          u => selectedResponsables.some(r => String(r.value) === String(u))
        );
        const programacion = row.original.programacionActual;
        return autorizado && !programacion? (
          <input
            type="checkbox"
            className="checkboox cursor-p font_sz"
            onChange={() => toggleEquipo(row.original)}
            checked={selectedEquipos.includes(row.original)}
          />
        ) : null;
      }
    }
  ], [responsablesIdsKey, toggleEquipo, selectedEquipos]);


const table = useReactTable({
    data: data.equipos,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel()
  });


  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  return (
    <div>
    <LoadingModal show={modalSpinner} text="Creando programación, por favor espere..."/>
    <Form>
    <Row>
        <Col xs={12} md={2}>
            <Button
                className=" ter w-100 d-flex align-items-center justify-content-center mb-3 mt-4"
                variant="warning"
                onClick={handleAbierta}
                disabled={data.otAbierta || !liderId || !fechaInicio || !fechaCierre}
            >
                {data.otAbierta? (
                <text className="success w-100">Orden Abierta</text>
                ) : ("Programar Abierta" )
                }
            </Button>
        </Col>
        <Col xs={12} md={6}>
            <Form.Group className="mb-3">
                <Row>
                    <Col><label>Responsables</label></Col>
                    {liderId ?
                    <Col>
                    <span
                      onClick={handleOpenModal}
                      style={{
                        color: "#0d6efd",
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                    >
                      Ver calendario del líder
                  </span>
                  </Col> : null}
                </Row>
                <Select
                  isMulti
                  options={responsables}
                  value={selectedResponsables}
                  onChange={(opts) => setSelectedResponsables(opts || [])}
                  placeholder="Seleccione uno o más metrólogos..."
                  noOptionsMessage={() => "Sin opciones"}
                />
                {selectedResponsables.length === 0 ? (
                  <small className="text-danger">*Campo Requerido</small>
                ) : (
                  <Form.Group className="mt-2">
                    <Form.Label className="mb-1"><small>Líder</small></Form.Label>
                    <Form.Select value={liderId} onChange={e => setLiderId(e.target.value)}>
                      {selectedResponsables.map(r => (
                        <option key={r.value} value={r.value}>{r.label}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                )}
            </Form.Group>
        </Col>
        <Col xs={12} md={4}>
            <Button
                className="w-100 d-flex align-items-center justify-content-center mb-3 mt-4"
                variant="primary"
                type="submit"
                onClick={handleSubmit}
                disabled={selectedEquipos.length === 0 || !liderId || !fechaInicio || !fechaCierre}
            >
                Programar
            </Button>
        </Col>
    </Row>
    <Row className="mb-4">
        <Col xs={12} md={4}>
            <Form.Group>
            <Form.Label>Fecha Inicio</Form.Label>
            <Form.Control
                type={"datetime-local"}
                value={fechaInicio}
                onChange={(e) => setFechaInicio(e.target.value)}
                min={new Date()}
            />
            {fechaInicio==="" ? (
              <small className="text-danger">*Campo Requerido</small>
            ):null
          }
            </Form.Group>
        </Col>
        <Col xs={12} md={4}>
            <Form.Group>
                <Form.Label>Fecha Cierre</Form.Label>
                <Form.Control
                    type={"datetime-local"}
                    value={fechaCierre}
                    onChange={(e) => setFechaCierre(e.target.value)}
                    disabled={!fechaInicio}
                    min={fechaInicio}
                />
                {fechaCierre==="" ? (
                  <small className="text-danger">*Campo Requerido</small>
                ):null
              }
            </Form.Group>
        </Col>
        <Col xs={12} md={2}>
            <Form.Group className="d-flex align-items-end h-100"
                style={{ boxShadow: 'none', outline: 'none', border: 'none' }}>
                <Form.Check 
                    type="checkbox"
                    className="checkboox cursor-p font_sz"
                    label="Autorizados"
                    checked={soloAutorizados}
                    onChange={() => {
                        const nuevoEstado = !soloAutorizados;
                        setSoloAutorizados(nuevoEstado);

                        if (nuevoEstado) {
                        // Seleccionar equipos autorizados para CUALQUIERA de los responsables.
                        const autorizados = data.equipos.filter(eq =>
                            eq?.snapshot?.userAutorizados?.some(
                              u => selectedResponsables.some(r => String(r.value) === String(u))
                            )
                        );
                        setSelectedEquipos(prev => {
                            // fusionar sin duplicar
                            const fusion = [...prev];
                            autorizados.forEach(eq => {
                            if (!fusion.some(e => e._id === eq._id)) {
                                fusion.push(eq);
                            }
                            });
                            return fusion;
                        });
                        } else {
                        // Si desactivas el check, opcional: limpiar solo los autorizados existentes
                        // o podrías simplemente no hacer nada aquí
                        setSelectedEquipos([]); // <-- solo si quieres limpiar
                        }
                    }}
                />
            </Form.Group>
        </Col>
        <Col xs={12} md={2}>
            <Form.Group className="d-flex align-items-end h-100"
                style={{ boxShadow: 'none', outline: 'none', border: 'none' }}>
                <Form.Check 
                    type="checkbox"
                    className="checkboox cursor-p font_sz"
                    label="Filtrados"
                    checked={selectAllFiltrados}
                    onChange={() => {
                    const visibleRows = table.getRowModel().rows.map(r => r.original);

                    if (!selectAllFiltrados) {
                        // ✅ AGREGAR SOLO LOS QUE NO ESTÁN Y ADEMÁS ESTÉN AUTORIZADOS
                        // (autorizado = cualquiera de los responsables seleccionados está en userAutorizados)
                        setSelectedEquipos(prev => {
                        const nuevos = visibleRows.filter(v => {
                            const autorizado = v.snapshot.userAutorizados.some(
                              u => selectedResponsables.some(r => String(r.value) === String(u))
                            );
                            return autorizado && !prev.some(p => p === v._id);
                        });
                        return [...prev, ...nuevos];
                        });
                    } else {
                        // ❌ Quitar solo los visibles (no importa si autorizados o no)
                        setSelectedEquipos(prev =>
                        prev.filter(p => !visibleRows.some(v => v._id === p._id))
                        );
                    }

                    setSelectAllFiltrados(!selectAllFiltrados);
                    }}
                    />
            </Form.Group>
        </Col>
        </Row>
    <div className="table-responsive">
      <table className="table table-striped table-bordered">
        <thead>
          {table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map(header => (
                <th key={header.id}>
                  {flexRender(header.column.columnDef.header, header.getContext())}

                  {/** ---> FILTRO POR COLUMNA <--- */}
                  {header.column.getCanFilter() ? (
                    <input
                      className="form-control form-control-sm mt-1"
                      placeholder="Filtrar..."
                      value={header.column.getFilterValue() ?? ""}
                      onChange={e => header.column.setFilterValue(e.target.value)}
                    />
                  ) : null}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody>
          {table.getRowModel().rows.map(row => (
            <tr key={row.id}>
              {row.getVisibleCells().map(cell => (
                <td key={cell.id}>
                  {flexRender(cell.column.columnDef.cell ?? cell.column.columnDef.accessorFn ?? cell.column.columnDef.accessorKey, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </Form>
    {/* Modal con CalendarioApp */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Calendario del Responsable</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CalendarioApp id={liderId} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ProgramacionPorEquipo;
